export { default } from "ember-moment/helpers/moment-add";
